import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import Section from 'components/Section'

import { doc, dirtyRead } from 'selectors/common'

import Employment from './Employment'

let select = (state, props) => ({
	application: doc(state, props.applicationID)
})

export class AdditionalResidents extends Component{
	render(){
		let { props } = this
		return(
			<div>
				{
					R.map(resident => {
						return (
							<Section
								id={`additionalResident${resident.firstName}${resident.lastName && resident.lastName[0]}`}
								title={`${resident.relation}: ${resident.firstName} ${resident.lastName && resident.lastName[0]}`}
							>
								<div className="additional-resident">
									<div className="age">
										<p>Age: {resident.age}</p>
									</div>
									<div className="relation">
										<p>Relation: {resident.relation}</p>
									</div>
									{resident.age.search("Child") == -1 &&
									<div>
										 <Employment data={resident.employment} />
									</div>
									}
								</div>
							</Section>
					)})(props.application.additionalResidents)
				}
			</div>
		)
	}
}
export default connect(select)(AdditionalResidents)



// WEBPACK FOOTER //
// ./src/routes/landlord/applicationForm/AdditionalResidents.js